/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { Center, Flex, Spinner, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import ItemsPagination from '@/components/wrappers/general/ItemsPagination'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getResourceAccessLogs } from '@/services/organization'
import { tableColumns } from './handlers'

const UserResourceAccessLogs = ({ organizationId }) => {
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    searchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getResourceAccessLogs,
    fetchParams: { organizationId }
  })

  if (loading) {
    return <Flex>
      <Center>
        <Spinner size='xl' />
      </Center>
    </Flex>
  }

  const TableHeader = ({ columns }) => (
    <Thead>
      <Tr>
        { columns.map(column => (
          <Th key={column.id}>
            { column.title }
          </Th>
        ))}
      </Tr>
    </Thead>
  )

  const rows = itemsResponse.userResourceAccessLogs?.map(item => {
    const columnsIds = tableColumns
      .map(column => column.title && column.id)
      .filter(Boolean)
    return (
      <Tr key={item.id}>
        {columnsIds.map((key, index) => (
          <Td key={index}>{ item[key] }</Td>
        ))}
      </Tr>
    )
  })
  return (
    <>
      <ItemsPagination
        currentPage={page}
        onChangePage={onChangePage}
        searchParams={searchParams}
        totalItems={itemsResponse?.total}
        totalPages={totalPages}
      >
        <TableContainer className="mb-6">
          <Table variant="simple">
            <TableHeader
              columns={tableColumns}
            />
            <Tbody>
              { rows }
            </Tbody>
          </Table>
        </TableContainer>
      </ItemsPagination>
    </>
  )
}

export default UserResourceAccessLogs
